<template>
    <topo>
        <template #botoes>
            <documentos/>
        </template>
        <template #usuario>
            <usuario/>
        </template>
    </topo>
</template>
<script>
export default {
    components: {
        Topo: () => import('@/shared/layouts/adminlte/components/Topo'),
        Documentos: () => import('./Documentos'),
        Usuario: () => import('@/shared/layouts/adminlte/components/Topo/shared/Usuario'),
    }
}
</script>